import { createApp } from "vue";

import App from "@/App.vue";
import { registerPlugins } from "@core/utils/plugins";

// Styles
import "@core/scss/template/index.scss";
import "@styles/styles.scss";
import { initializeBugsnag } from "./plugins/bugsnag";
import { notifyBug } from "./utils/notifyBug";
import { vMaska } from "maska/vue";
import { VueDraggableNext } from 'vue-draggable-next'
import { AmplitudeService } from "./services/amplitude";
import { setupDiscordErrorHandlers, setupJavaScriptErrorHandler, setupPromiseErrorHandler } from "./plugins/discord";

AmplitudeService.init();
// Create vue app
const app = createApp(App);

// ============================================
// 🐛 BUGSNAG + 🎯 DISCORD - Notificações de Erros
// ============================================
import { discordService } from "./plugins/discord";

const bugSnagApiKey = "0709918e5e0ec2d8bfad9d6575186e3a";
if (bugSnagApiKey) {
  initializeBugsnag(app);
  
  // Error Handler: envia para Bugsnag E Discord
  app.config.errorHandler = (err, vm, info) => {
    // Bugsnag (existente)
    notifyBug(err);
    console.error(err);
    
    // Discord (novo)
    discordService.notifyError({
      type: 'vue',
      error: err,
      context: {
        componentName: vm?.$options.name || vm?.$options.__name || 'Unknown Component',
        lifecycle: info,
        route: window.location.pathname,
        url_page: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date(),
      },
      severity: 'high',
    });
  };
}

// Configurar handlers de JavaScript e Promise (Discord)
setupJavaScriptErrorHandler();
setupPromiseErrorHandler();
console.log('✅ Discord: Sistema de notificações configurado!');
// ============================================

app.component("Draggable", VueDraggableNext)
app.directive("maska", vMaska);
// Register plugins
registerPlugins(app);

// Mount vue app
app.mount("#app");
